import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';
import {UserService} from '../../services/user.service';
import{ArticleService} from '../../services/article.service';

declare var $:any;//Required for jquery use

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit ,IRule {

  @HostBinding('style.width') public width: string = '100%';

  userName='';
  navigationsType=[];
  notification:any=[];
  msg:any;
	toastr:any;
  _router:any;
  token:any='';
  per_page:number=10;
  loader_image:boolean =true
  userId:any;
  name:any='';
  email:any='';
  role:any='';
  screenName:any='';
  departmentList:any=[];
  msgSubscribe:Subscription;

  constructor(private route:ActivatedRoute,msg:MessageService, toastr: ToastrService, _router: Router,private userService:UserService,private articleService:ArticleService) { 
  	this.msg = msg;
    this.toastr = toastr;
    this._router =_router;

    this.msgSubscribe=   this.msg.getMessage().subscribe( (evt) => {
     
      if(evt!=undefined){

         
       switch(evt.text.type){
         
         case 'profile':

         let res= evt.text.data
         this.userName=res.user.name;

        this.navigationsType=res.navigation;

        this.notification =res.notification;

        this.broadcast_menu();

        this.userId=res.user.id
        this.name =res.user.name
        this.email = res.user.email
        this.role = res.role[0]
        this.departmentList=res.department;
        if(res.user.department!=undefined){
          this.screenName =res.user.department
        }
         
         break;


       }

      }

   });
   
  }

  ngOnInit() {

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);
      this.token = tokenA.token;

    }catch(error){

      this._router.navigate(['/login']);

    }

    if(this.userId==undefined){
      this._router.navigate(['/home']);
    }
    setTimeout(() => {
      this.loader_image=false
    }, 500);
    
  }

  ngOnDestroy() {

    this.msgSubscribe.unsubscribe();
	  

  } 

  ngAfterViewInit(){
    $(document).ready(function(){ 
      $('input').blur(function(event) {
      var inputValue = this.value;
      if (inputValue) {
        this.classList.add('value-exists');
      } else {
        this.classList.remove('value-exists');
      }
      });
      });
  }


  updateProfile(){
    
    let data={
      token:this.token,
      id:this.userId,
      department:this.screenName,
      page:'profile'
    }
  
    this.userService.getUserList(data).subscribe( (response)=>{
  
              if(response.status=='success'){
                this.toastr.success('Profile update successfully', '', {timeOut: 3000});
                this._router.navigate(['/home']);
              } else{
  
                this.toastr.error('Profile updation failed. Please try again later', '', {timeOut: 3000});
              }
  
    });
    // let val= this.departmentList.filter( (item,k) => { return  item.value == this.screenName});
    // console.log('vvv',val)
  }

  broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
  } 

}

